import queryString from "query-string";
import {
  getService,
  patchService,
  postService,
  putService,
} from "../../../commonServices";
import { appBaseUrl } from "utils/config";

export class DynamicCircularService {
  // get all company of the circular list
  getCircularPlanningCompany(id) {
    //allDynamicCircularPlanningCompanyDto
    let url = `${appBaseUrl}/referenceManagement/allCircularPlanningCompanyDto?CircularPlanningTemplateId=${id}`;
    let data = getService(url);
    return data;
  }

  getAllCircularPlanningTemplate() {
    //allDynamicCircularPlanningTemplate
    let url = `${appBaseUrl}/referenceManagement/allCircularPlanningTemplate`;
    let data = getService(url);
    return data;
  }

  // Add Circular tempalte
  addCircularPlanningTemplate(body) {
    //dynamicCircularPlanningTemplate
    let url = `${appBaseUrl}/referenceManagement/CircularPlanningTemplate`;
    let data = postService(url, body);
    return data;
  }

  // add/updated company
  updateCircularPlanningCompany(body) {
    //dynamicCircularPlanningCompany
    let url = `${appBaseUrl}/referenceManagement/CircularPlanningCompany`;
    let data = postService(url, body);
    return data;
  }
  // add/updated company
  addCircularPlanningCompanyFromList(body) {
    //dynamicCircularPlanningCompany
    let url = `${appBaseUrl}/referenceManagement/CircularPlanningCompany`;
    let data = postService(url, body);
    return data;
  }
}
